export const gameTypes = {
  'Account Classification': 'Classification',
  'Normal Balance': 'Normal', 
  'Balanced Equation': 'Balanced Equation',
  'The Principles': 'Principles'
};

export const tableHeaders = ['Assignments', 'First Attempt', 'Second Attempt', 'Third Attempt'];